import { render, staticRenderFns } from "./salary comparison.vue?vue&type=template&id=9019cad6"
import script from "./salary comparison.vue?vue&type=script&lang=js"
export * from "./salary comparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports